module.exports = __webpack_public_path__ + "img/A户型品鉴-右_image.2c5928a9.png";